import { useEffect } from 'react';

// Per-page SEO: sets document.title and <meta name="description"> while the page is mounted,
// and restores the previous values on unmount / when args change. No external dependency.
// Pass null/undefined to skip (keeps the site defaults from index.html).
export const useSeo = (title, description) => {
  useEffect(() => {
    if (!title && !description) return undefined;

    const prevTitle = document.title;
    let meta = document.querySelector('meta[name="description"]');
    let created = false;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
      created = true;
    }
    const prevDesc = meta.getAttribute('content');

    if (title) document.title = title;
    if (description) meta.setAttribute('content', description);

    return () => {
      document.title = prevTitle;
      if (created) {
        meta.remove();
      } else if (description && prevDesc !== null) {
        meta.setAttribute('content', prevDesc);
      }
    };
  }, [title, description]);
};
